import { ATTACHMENTS } from "../../api/endpoints";
import { baseApi } from "./baseApi";

const multipart = typeof FormData !== "undefined" ? {} : {};

export const attachmentsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    uploadAttachment: build.mutation({
      query: (formData) => ({
        url: ATTACHMENTS.LIST,
        method: "POST",
        data: formData,
        ...multipart,
      }),
    }),

    getAttachmentById: build.query({
      query: (id) => ({
        url: ATTACHMENTS.BY_ID(id),
        method: "GET",
      }),
    }),

    downloadAttachment: build.mutation({
      query: (id) => ({
        url: ATTACHMENTS.DOWNLOAD(id),
        method: "GET",
        responseType: "blob",
      }),
    }),
  }),
});

export const {
  useUploadAttachmentMutation,
  useGetAttachmentByIdQuery,
  useDownloadAttachmentMutation,
} = attachmentsApi;
